"use strict";
/**
 * Class description
 *
 * Created: 2017-11-22
 * @author jonas
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameIntroView = exports.IntroFeatureLogo = void 0;
const FontStatics_1 = require("@nolimitcity/slot-launcher/bin/loader/font/FontStatics");
const Button_1 = require("../component/Button");
const LoaderButton_1 = require("../component/LoaderButton");
const GameResources_1 = require("../resource/GameResources");
const ScreenView_1 = require("../screen/ScreenView");
const Orientation_1 = require("../stage/Orientation");
const Translation_1 = require("../translation/Translation");
const gsap_1 = require("gsap");
const DynamicTextsLine_1 = require("../component/DynamicTextsLine");
var IntroFeatureLogo;
(function (IntroFeatureLogo) {
    IntroFeatureLogo["VOLATILITY_EXTREME"] = "volatilityExtreme";
    IntroFeatureLogo["VOLATILITY_HIGH"] = "volatilityHigh";
    IntroFeatureLogo["VOLATILITY_MEDIUM"] = "volatilityMed";
    IntroFeatureLogo["X_NUDGE"] = "xNudge";
    IntroFeatureLogo["X_WAYS"] = "xWays";
})(IntroFeatureLogo = exports.IntroFeatureLogo || (exports.IntroFeatureLogo = {}));
class GameIntroView extends ScreenView_1.ScreenView {
    constructor(config) {
        super(config);
        this.DEFAULT_BRAND_NAME = "NOLIMIT CITY";
        this.DEFAULT_BRAND_TEXT_STYLES = {
            brand: {
                fontFamily: "Open Sans",
                fontSize: 15,
                fill: "#ffffff",
                fontWeight: FontStatics_1.FontWeight.BOLD,
                align: "left"
            },
            production: {
                fontFamily: "Open Sans",
                fontSize: 15,
                fill: "#ffffff",
                fontWeight: FontStatics_1.FontWeight.LIGHT,
                align: "left"
            }
        };
        this.DEFAULT_BRAND_TEXT_PADDING = 15;
        this._introConfig = config;
    }
    // helping in the hack to load translations before initializing legacy game intro.
    introAssetsAndTranslationsLoaded(data) {
        if (this._button || this._brandText) {
            return;
        }
        this._resizeData = data;
        if (this.initAnimations) {
            this.initAnimations();
        }
        this._hasInit = true;
        if (this.onResize) {
            this._isResizeDirty = false;
            this.onResize(this._resizeData);
        }
    }
    initAnimations() {
        super.initAnimations();
        this._brandText = this.createBrandText();
        this.addChild(this._brandText);
        if (this._introConfig.featureIcons) {
            this._featureLogoContainer = this.createFeatureLogos();
            this.addChild(this._featureLogoContainer);
        }
    }
    createBackground() {
        return new PIXI.Graphics();
    }
    createButton() {
        const continueTranslation = Translation_1.Translation.translate(this._config.buttonText ? this._config.buttonText : "CONTINUE");
        const loadingTranslation = Translation_1.Translation.translate("LOADING");
        const textStyle = this.getScaledButtonTextStyle();
        const button = new LoaderButton_1.LoaderButton(() => this._onButtonClickCallback(), ` ${continueTranslation} `, ` ${loadingTranslation} `, textStyle);
        button.enabled = false;
        return button;
    }
    createBrandText() {
        const textStyles = (this._introConfig.brand != null && this._introConfig.brand.brandTextStyles != null) ? this._introConfig.brand.brandTextStyles : this.DEFAULT_BRAND_TEXT_STYLES;
        const dynamicText = new DynamicTextsLine_1.DynamicTextsLine(0.5, 0, new PIXI.Point(0, 0));
        dynamicText.createText(Translation_1.Translation.translate("A "), textStyles.production);
        dynamicText.createText((this._introConfig.brand != null && this._introConfig.brand.brandName != null) ? this._introConfig.brand.brandName : this.DEFAULT_BRAND_NAME, textStyles.brand);
        dynamicText.createText(Translation_1.Translation.translate(" PRODUCTION"), textStyles.production);
        dynamicText.arrange();
        dynamicText.alpha = 0.6; // TODO: config?
        return dynamicText;
    }
    createFeatureLogos() {
        const container = new PIXI.Container();
        const logoSpace = this._introConfig.featureIcons.logoSpace != null ? this._introConfig.featureIcons.logoSpace : 20;
        let logoPosition = 0;
        this._introConfig.featureIcons.icons.forEach((logoName) => {
            const logo = new PIXI.Sprite(GameResources_1.GameResources.getTextures(logoName)[0]);
            logo.anchor.set(0, 0.5);
            logo.position.set(logoPosition, 0);
            container.addChild(logo);
            logoPosition += logo.width + logoSpace;
        });
        return container;
    }
    startPresentation(data, onShowComplete) {
        this._button.setState(Button_1.ButtonState.loading);
        super.startPresentation(data, onShowComplete);
    }
    onResize(data) {
        if (!this._isShowing) {
            this._isResizeDirty = true;
            return;
        }
        super.onResize(data);
        this.onResizeBrandText(data);
        if (this._featureLogoContainer) {
            this.onResizeFeatureLogos(data);
        }
    }
    onResizeBackground(data) {
        const background = this._background;
        background.clear();
        background.beginFill(0x000000, 1.0);
        background.drawRect(0, 0, this._screenWidth, this._screenHeight);
        background.endFill();
    }
    onResizeBrandText(resizeData) {
        const scale = this._orientationScale * this._deviceScale;
        const padding = ((this._introConfig.brand != null && this._introConfig.brand.brandTextPadding) ? this._introConfig.brand.brandTextPadding : this.DEFAULT_BRAND_TEXT_PADDING) * scale;
        this._brandText.setScale(scale);
        if (resizeData.orientation === Orientation_1.Orientation.PORTRAIT) {
            this._brandText.setAnchor(0.5, 0);
            this._brandText.position.set(this._screenWidth / 2, padding);
        }
        else {
            this._brandText.setAnchor(0, 0);
            this._brandText.position.set(padding, padding);
        }
    }
    onResizeFeatureLogos(resizeData) {
        const sideBorder = this._introConfig.featureIcons.sideBorder != null ? this._introConfig.featureIcons.sideBorder : 20;
        const bottomBorder = this._introConfig.featureIcons.bottomBorder != null ? this._introConfig.featureIcons.bottomBorder : 20;
        const scale = 0.8 * this._orientationScale * this._deviceScale;
        this._featureLogoContainer.scale.set(scale);
        if (resizeData.orientation === Orientation_1.Orientation.PORTRAIT) {
            const x = bottomBorder * 1.8; // TODO: bottom border.
            this._featureLogoContainer.position.set(this._screenWidth / 2 - this._featureLogoContainer.width / 2, this._screenHeight - this._featureLogoContainer.height / 2 - x);
        }
        else {
            const x1 = sideBorder * scale; // TODO: side border.
            const x2 = bottomBorder * scale; // TODO: bottom border.
            this._featureLogoContainer.position.set(0 + x1, this._screenHeight - this._featureLogoContainer.height / 2 - x2);
        }
    }
    stopPresentation(closeCallback) {
        let tl = new gsap_1.TimelineLite();
        tl.add(new gsap_1.TweenLite(this, 0.3, { alpha: 0 }));
        tl.add(() => super.stopPresentation(closeCallback));
    }
    updateLoadProgress(progress) {
        if (this._hasInit == true) {
            progress = Math.round(progress);
            this._button.updateMask(progress / 100);
        }
    }
}
exports.GameIntroView = GameIntroView;
//# sourceMappingURL=GameIntroView.js.map